import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import HistoricalAnalytics from './HistoricalAnalytics';

const TABS = [
  { id: 'overview', label: 'Overview' },
  { id: 'dossiers', label: 'Dossiers' },
  { id: 'timeline', label: 'Timeline' },
];

const AnalyticsDashboard = () => {
  const [activeTab, setActiveTab] = useState('overview');

  return (
    <div className="min-h-screen bg-[radial-gradient(circle_at_top,_rgba(255,248,236,0.98),_rgba(239,229,214,0.96)_42%,_rgba(228,237,243,0.92)_100%)] text-[#1f1912]">
      <header className="sticky top-0 z-30 border-b border-black/5 bg-[rgba(245,237,225,0.94)] backdrop-blur">
        <div className="mx-auto flex w-full max-w-[1650px] flex-col gap-4 px-4 py-4 sm:px-6 lg:px-8">
          <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
            <div className="min-w-0">
              <p className="text-[11px] font-semibold uppercase tracking-[0.32em] text-[#8b6b42]">
                Internal analytics
              </p>
              <div className="mt-2 flex items-center gap-3">
                <h1 className="text-2xl font-semibold tracking-tight text-[#18130d] sm:text-3xl">
                  Operator workspace
                </h1>
                <Link
                  to="/"
                  className="rounded-full border border-[#d9c9b2] bg-white/70 px-3 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-[#5d4b35] transition hover:-translate-y-0.5 hover:bg-white"
                >
                  Back to site
                </Link>
              </div>
              <p className="mt-2 max-w-3xl text-sm leading-6 text-[#5f5448] sm:text-base">
                Human traffic first. Bot traffic and asset hits stay visible, but the default view stays clean.
              </p>
            </div>

            <div className="flex flex-wrap gap-2">
              <HeaderChip label="Human first" value="Default" />
              <HeaderChip label="Wide layout" value="Full bleed" />
              <HeaderChip label="Export" value="CSV" />
            </div>
          </div>

          <nav role="tablist" aria-label="Analytics sections" className="flex flex-wrap gap-2">
            {TABS.map((tab) => (
              <TabButton
                key={tab.id}
                active={tab.id === activeTab}
                onClick={() => setActiveTab(tab.id)}
                label={tab.label}
              />
            ))}
          </nav>
        </div>
      </header>

      <main className="mx-auto w-full max-w-[1650px] px-4 py-5 sm:px-6 lg:px-8 lg:py-8">
        <HistoricalAnalytics activeTab={activeTab} />
      </main>
    </div>
  );
};

const TabButton = ({ active, onClick, label }) => (
  <button
    type="button"
    role="tab"
    aria-selected={active}
    onClick={onClick}
    className={`rounded-full px-4 py-2 text-sm font-semibold transition ${
      active
        ? 'bg-[#1f4f67] text-white shadow-[0_10px_28px_-16px_rgba(31,79,103,0.95)]'
        : 'border border-[#d8c8b2] bg-white/70 text-[#5b4a36] hover:bg-white'
    }`}
  >
    {label}
  </button>
);

const HeaderChip = ({ label, value }) => (
  <div className="rounded-[20px] border border-white/80 bg-white/72 px-4 py-3 shadow-[0_18px_40px_-34px_rgba(43,31,14,0.45)]">
    <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#8b7a68]">{label}</p>
    <p className="mt-1 text-sm font-semibold text-[#1f1913]">{value}</p>
  </div>
);

export default AnalyticsDashboard;
